export const FACTOR_RULE_INFO_LABELS = {
  BETA: "Beta",
  COUNTRY: "Country",
  CURRENCY: "Currency",
} as const

export const BETA_TYPES = {
  PREDICTED: "predicted",
  HISTORICAL: "historical",
} as const

export const FACTOR_RULE_DISPLAY_TYPES = {
  EXPOSURE: "exposure",
  COMPOSITION: "composition",
} as const
